<template>
  <div class="flex flex-1 flex-col justify-center items-center w-full sm:mt-10 custom-login-container">
    <el-form class="sm:w-full sm:max-w-md">
      <div class="progress" v-show="loginLoading">
        <div class="progress-bar-indeterminate"></div>
      </div>
      <el-form-item label="Email">
        <el-input v-model="email" placeholder="Email" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="Password">
        <el-input v-model="password" placeholder="Password" type="password" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="rememberMe">Remember Me</el-checkbox>
      </el-form-item>
      <el-button type="primary" @click="login">Login</el-button>
      <span class="text-xs uppercase text-grey-light mx-4">or</span>
      <el-button type="default" @click="nfc">Switch to NFC</el-button>
      <div class="bg-red-400 p-4 mt-4 text-white rounded" v-show="loginError">
        {{ loginError }}
      </div>
    </el-form>
    <p class="self-end text-gray-400 mt-8 text-sm text-center sm:self-center">&copy; {{ year }} Toate drepturile rezervate</p>
  </div>
</template>


<script>
import Cookies from 'js-cookie'
import axios from 'axios'

export default {
  name: 'Login',
  data: () => {
    return {
      loginError: null,
      loginLoading: false,
      email: localStorage.getItem('email') || null,
      password: localStorage.getItem('password') || null,
      rememberMe: localStorage.getItem('rememberMe') === 'true' // Verificăm dacă a fost activat
    }
  },
  computed: {
    year () {
      return new Date().getFullYear();
    }
  },
  methods: {
    nfc() {
      this.$router.push({ name: 'nfc' })
    },
    login(event) {
      event.preventDefault()
      this.loginError = null
      this.loginLoading = true

      axios.post(process.env.VUE_APP_API_URL + 'auth/login', {
        email: this.email,
        password: this.password
      })
        .then(({ data }) => {
          let to = ''
          if (data.role === 1) {
            to = process.env.VUE_APP_URL_ADMIN
          } else if (data.role === 2) {
            to = process.env.VUE_APP_URL_MANAGER
          } else if (data.role === 3) {
            to = process.env.VUE_APP_URL_EMPLOYEE
          } else if (data.role === 4) {
            to = process.env.VUE_APP_URL_STAFF
          } else if (data.role === 5) {
            to = process.env.VUE_APP_URL_CASHIER
          }

          localStorage.setItem('lastLoginMethod', 'email')
          
          // Setăm datele de login în localStorage dacă "Remember Me" este selectat
          if (this.rememberMe) {
            localStorage.setItem('email', this.email)
            localStorage.setItem('password', this.password)
            localStorage.setItem('rememberMe', 'true')
          } else {
            localStorage.removeItem('email')
            localStorage.removeItem('password')
            localStorage.setItem('rememberMe', 'false')
          }
          
          // Setăm token-urile și redirecționăm utilizatorul
          Cookies.set('lastLoginMethod', 'email', { domain: process.env.VUE_APP_COOKIE_DOMAIN })
          Cookies.set('token', data.access_token, { domain: process.env.VUE_APP_COOKIE_DOMAIN })
          Cookies.set('token_type', data.token_type, { domain: process.env.VUE_APP_COOKIE_DOMAIN })
          Cookies.set('role', data.role, { domain: process.env.VUE_APP_COOKIE_DOMAIN })
          Cookies.set('token_expires_in', data.expires_in, { domain: process.env.VUE_APP_COOKIE_DOMAIN })
          window.location.href = to
        })
        .catch((err) => {
          console.log(err)
          this.loginLoading = false
          this.loginError = (err.response && err.response.data.message) ? err.response.data.message : err.message
        })
    }

  }
}
</script>
<style scoped>
.custom-login-container {
  min-height: 100vh; /* Se asigură că ocupă întreaga înălțime a ecranului */
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Pe ecrane mari, să fie la început */
  padding-top: 50px; /* La început, poate avea o marjă sus pe ecrane mari */
}

@media (max-width: 640px) {
  .custom-login-container {
    justify-content: center; /* Pe ecrane mici, să fie centrat pe verticală */
    padding-top: 0; /* Eliminăm padding-ul de sus pentru a face login-ul mai sus */
  }
}
</style>
